// Array of field configurations
import { FormField } from "./Types";

// Array of field configurations
export const formFields: FormField[] = [
    {
        label: "Promocode",
        name: "promoCode",
        type: "text",
        required: "Promo Code is required",
    },

    {
        label: "Type",
        name: "type",
        type: "select",
        options: [
            { value: 1, label: "Percentage" },
            { value: 2, label: "Amount" },
        ],
        required: "Type is required",
    },
    {
        label: "Offer Value",
        name: "offerValue",
        type: "number",
        required: "Offer Value is required",
    },
    {
        label: "Max Discount",
        name: "maxDiscount",
        type: "number",
        required: "Max Discount is required",
    },
    {
        label: "Start Date",
        name: "startDate",
        type: "date",
        required: "Start Date is required",
    },
    {
        label: "End Date",
        name: "endDate",
        type: "date",
        required: "End Date is required",
    },
    {
        label: "Description",
        name: "description",
        type: "textarea",
        required: "Description is required",
    },
];

export const breadcrumbItems = [
    { label: "Promocodes", link: "/auth/promocodes" },
];
